import { useEffect, useState } from 'react';

const MOBILE_QUERY = '(max-width: 767px)';

/** True when the viewport is phone-sized. Reactive to resize/rotate. */
export function useIsMobile(query: string = MOBILE_QUERY): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(
    () => typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false,
  );
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(query);
    const handler = () => setIsMobile(mq.matches);
    handler();
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [query]);
  return isMobile;
}

// Session opt-out: when a mobile owner chooses "Vista completa", we stop
// auto-redirecting them to /movil for the rest of the browser session.
const FULL_VIEW_KEY = 'bi:fullView';
export function prefersFullView(): boolean {
  try { return sessionStorage.getItem(FULL_VIEW_KEY) === '1'; } catch { return false; }
}
export function setPreferFullView(): void {
  try { sessionStorage.setItem(FULL_VIEW_KEY, '1'); } catch { /* private mode */ }
}
